import { render, staticRenderFns } from "./defaultPageHeader.vue?vue&type=template&id=f4e8efac"
import script from "./defaultPageHeader.vue?vue&type=script&lang=js"
export * from "./defaultPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports